import { Schema as S } from "effect";
export const stringFromPrefixedString = (prefix, schema)=>{
    const stringWithPrefixSchema = S.TemplateLiteral(prefix, schema.pipe(S.encodedSchema));
    const transformed = S.transform(stringWithPrefixSchema, schema.pipe(S.encodedSchema), {
        decode: (fromA)=>{
            return fromA.slice(prefix.length);
        },
        encode: (toI)=>{
            return `${prefix}${toI}`;
        },
        strict: true
    });
    return S.compose(transformed, schema);
};
export const stringFromOptionallyPrefixedString = (prefix, schema)=>{
    const stringWithOptionalPrefixSchema = S.Union(S.TemplateLiteral(prefix, schema.pipe(S.encodedSchema)), schema.pipe(S.encodedSchema));
    const transformed = S.transform(stringWithOptionalPrefixSchema, schema.pipe(S.encodedSchema), {
        decode: (fromA)=>{
            if (fromA.startsWith(prefix)) {
                return fromA.slice(prefix.length);
            }
            return fromA;
        },
        encode: (toI)=>{
            return `${prefix}${toI}`;
        },
        strict: true
    });
    return S.compose(transformed, schema);
};
